export default __webpack_public_path__ + "static/media/airTeam.6fb1fd20.png";